// extracted by mini-css-extract-plugin
export default {"loginWithGoogleImage":"CalendarLoginButton_loginWithGoogleImage__DvPaT"};